

export const PERSONALINFO = Object.freeze({
    firstname: "Wei Jian",
    lastname: "Tan",
    email: "weijiant02@gmail.com",
    phone: "+6019 4780959",
    githubLink: "https://github.com/nullVallue",
    linkedInLink : "https://www.linkedin.com/in/wei-jian-tan/",
    instagramLink : "https://www.instagram.com/wei_jiantan",
    aboutMePic: require("../../assets/me/aboutMePic3.jpg"),
    aboutMePicAlt: "A picture of me :)",
    aboutMeText: 
    `I'm an independent FullStack Software Developer that loves  crafting visually stunning websites. I believe that knowing a little about everything is always better than knowing everything about a lot. If you'd like to work with me just hit me up!
    `,
});